import "../../style/page/ProductOrderpage.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  productorder,
  productorderid,
  sidebar,
} from "../../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import {
  ProductOrderGet,
  pharmacytrackorder,
  pharmacy_status_bypass,
  pharmacyrequest
} from "../../../text/apidata";
import BasicTable from "../../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import noimage1 from "../../../assets/images/noimage.png";
import ProductOrderFormNew from "../../form/pharmacynew/productorderformnew";
import PharmacyProductReturn from "../../form/pharmacynew/pharmacy_product_return";
import noimage from "../../../assets/images/noimage.png";
import pdf from "../../../assets/images/pdf.png";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Chart } from "react-google-charts";
import Swal from "sweetalert2";

function ProductOrderNew(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.productorder);
  const productid = useSelector((state) => state.counter.productorderid);
  const [trackorderidp, settrackorderidp] = useState("");
  const [trackorderstatep, settrackorderstatep] = useState(false);
  console.log(trackorderstatep);
  const [trackorderdatap, settrackorderdatap] = useState([]);
  const [timeString, settimeString] = useState("");
  const [proceedpaymentstate, setproceedpaymentstate] = useState("True");
  const [pharmaStatus, setPharmaStatus] = useState("all");
  const [byPassStatus, setByPassStatus] = useState(false);
  const [deliveryType, setDeliveryType] = useState("all");
  const [pharmacyOrderData, setPharmacyOrderData] = useState(true)
  const locationid = useSelector((state) => state.counter.loginuser_location_id)
  const [branches, setbranches] = useState(locationid != "all" ? locationid : "91");
  const navigate = useNavigate()
  const [returnpopup, setreturnpopup] = useState(false)
  var today = new Date();
  // var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);
  const [range, setrange] = useState([gt, it]);
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const [pieChartData, setPieChartData] = useState({
    confirming_order: 2,
    packing_order: 4,
    in_transit: 2,
    delivered: 2,
  });
  // for pie chart
  const pie_chart_data = [
    ["Pharmacy", "count"],
    ["Confirming order", pieChartData.confirming_order],
    ["Packing Order", pieChartData.packing_order],
    ["In Transit", pieChartData.in_transit],
    ["Delivered", pieChartData.delivered],
  ];
  const options = {
    title: "Pharmacy order status",
    pieHole: 0.5,
    is3D: false,
    slices: {
      1: { color: "grey" },
      3: { color: "green" },
    },
  };
  useEffect(() => {
    if (trackorderidp != "") {
      console.log(trackorderidp, "trackorderidp");
      axios({
        method: "get",
        url: pharmacytrackorder + trackorderidp + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          settrackorderdatap(res.data.data);
          console.log(res, "sdsd");
          var dateTimeString = res.data.data.order.created_date;
          // Create a Date object from the string
          var dateTime = new Date(dateTimeString);
          // Extract hours, minutes, and seconds
          var hours = dateTime.getHours();
          var minutes = dateTime.getMinutes();
          var seconds = dateTime.getSeconds();
          // Format the time as a string
          settimeString(hours + ":" + minutes + ":" + seconds);
          console.log(timeString);
        })
        .catch((error) => {
          props.popupalert("true");
          props.popuptext("TrackOrder does not exist.");
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
          props.loaderchange("false");
        });
    }
  }, [trackorderidp]);

  useEffect(() => {
    if (byPassStatus == true) {
      axios({
        method: "get",
        url: pharmacy_status_bypass + productid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          props.popuptext("Product Order status Updated Successfully");
          console.log(res, "res");
        })
        .catch((error) => {
          props.popuptext("Updation failed");
        });
      setByPassStatus(false);
    }
  }, [byPassStatus]);

  const bypassdeliverystatus = (order_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to change the status to delivered",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change status.",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatchid(productorderid(order_id));
        //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
        setByPassStatus(true);
      }
    });
  };
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        axios({
          method: "get",
          url: ProductOrderGet,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            // sample_invoice_requested: "True",
            bill_request_given: "True",
            invoice_given: "true",
            proceed_payment: proceedpaymentstate,
            date_gt: range[0],
            date_lt: range[1],
            status: pharmaStatus,
            order_list: "true",
            deliveryType: deliveryType,
            remove_from_order: false,
            branch: branches,

          },
        })
          .then((res) => {
            console.log(res);
            let status_obtain = {
              confirming_order: res.data.data.confirming_order,
              packing_order: res.data.data.packing_order,
              in_transit: res.data.data.in_transit,
              delivered: res.data.data.delivered,
            };
            setPieChartData(status_obtain);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      axios({
        method: "get",
        url: ProductOrderGet,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          sample_invoice_requested: "True",
          bill_request_given: "True",
          proceed_payment: proceedpaymentstate,
          date_gt: range[0],
          date_lt: range[1],
          status: pharmaStatus,
          order_list: "true",
          deliveryType: deliveryType,
          remove_from_order: false,
          branch: branches,

        },
      })
        .then((res) => {
          console.log(res);
          let status_obtain = {
            confirming_order: res.data.data.confirming_order,
            packing_order: res.data.data.packing_order,
            in_transit: res.data.data.in_transit,
            delivered: res.data.data.delivered,
          };
          setPieChartData(status_obtain);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data.data);
          // setPharmacyOrderData(false)
        })
        .catch((error) => {
          // setPharmacyOrderData(false)
          console.log(error);
        });
    }
  }, [
    dtpageindex,
    dtpagesize,
    searchQuery,
    productstate,
    proceedpaymentstate,
    pharmaStatus,
    range,
    deliveryType,
    pharmacyOrderData,
    branches
  ]);

  const handle_remove_from_order = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to remove this order from this table",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove order.",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "put",
          url: pharmacyrequest + id + "/",
          data: {
            remove_from_order: true,
            deny_proceed_to_pay: true
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            props.popuptext("Order removed from table");
            console.log(res, "res");
            setPharmacyOrderData(!pharmacyOrderData)
          })
          .catch((error) => {
            props.popuptext("Updation failed");
            setPharmacyOrderData(!pharmacyOrderData)
          });
      }
    });
  }
  const dropdownhandlechange = (id, e) => {
    dispatchid(productorderid(id));
    dispatch(productorder("Edit"));
    // alert("Can't edit ")
    // console.log("not possible")
    // console.log(proceedpaymentstate,"test")
  };
  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Delivery in hospital",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  style={{ width: "100px" }}
                  class="btn btn-danger btn-sm edit"
                  disabled={
                    row.row.original.request_from_hospital == true
                      ? false
                      : true
                  }
                  onClick={(e) => {
                    bypassdeliverystatus(row.row.original.id);
                    e.stopPropagation();
                  }}
                >
                  <i class="bi bi-pencil-fill"></i> Edit status
                </button>
              </div>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  style={{ width: "60px" }}
                  class="btn btn-danger btn-sm edit"
                  disabled={
                    row.row.original.proceed_payment != true ? true : false
                  }
                  onClick={(e) => {
                    dropdownhandlechange(row.row.original.id, e);
                    e.stopPropagation();
                  }}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
      {
        Header: "Remove from orders",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  style={{ width: "70px" }}
                  class="btn btn-danger btn-sm edit"
                  disabled={
                    row.row.original.proceed_payment == false ? false : true
                  }
                  onClick={(e) => {
                    handle_remove_from_order(row.row.original.id)
                    // dropdownhandlechange(row.row.original.id, e);
                    e.stopPropagation();
                  }}
                >
                  {/* <i class="bi bi-pencil-fill"></i>  */}
                  Remove
                </button>
              </div>
            </>
          );
        },
      },
      // {
      //   Header: "Return orders",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <div class="actions">
      //           <button
      //             type="button"
      //             style={{ width: "80px" }}
      //             class="btn btn-danger btn-sm edit"
      //             onClick={(e) => {
      //               e.stopPropagation()
      //               setreturnpopup(true)
      //               settrackorderidp(row.row.original.id)
      //             }}
      //           >
      //             <i class="bi bi-pencil-fill mr-1"></i>
      //             Return
      //           </button>
      //         </div>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Created date",
        accessor: "",

        Cell: (row) => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                  }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "Request from",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p>
                {row.row.original.request_from_hospital == true
                  ? "Hospital"
                  : "Home"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Bill ID",
        accessor: "",

        Cell: (row) => {
          var final_id = "--"
          if (row.row.original.ordercreaterazorpay != null) {
            if (row.row.original.ordercreaterazorpay.isPaid == true) {
              final_id = String(row.row.original.id).slice(-12)
            }
          } else if (row.row.original.fully_used == true) {
            final_id = String(row.row.original.id).slice(-12)
          }

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={final_id}
              >

                {final_id}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(final_id));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Wallet ID",
        accessor: "",

        Cell: (row) => {
          var final_walet_id = "--"
          if (row.row.original.ordercreaterazorpay != null) {
            if (row.row.original.ordercreaterazorpay.isPaid == true) {
              if (row.row.original.wallet_id == null) {
                final_walet_id = "--"
              } else {
                final_walet_id = row.row.original.wallet_id
              }
            }
          } else if (row.row.original.fully_used == true) {
            if (row.row.original.wallet_id == null) {
              final_walet_id = "--"
            } else {
              final_walet_id = row.row.original.wallet_id
            }
          }
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={final_walet_id}
              >
                {final_walet_id}
              </p>
            </>
          );
        },
      },
      {
        Header: "Bill Request Pharmafile",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <img
                  style={{
                    height: "2.5rem",
                    width: "2.5rem",
                    // borderRadius: "50%",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    {
                      row.row.original.bill_request_pharmafile != null &&
                        window.open(
                          row.row.original.bill_request_pharmafile != null
                            ? row.row.original.bill_request_pharmafile
                            : ""
                        );
                    }
                  }}
                  className="pointer"
                  src={
                    row.row.original.bill_request_pharmafile != null
                      ? /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(
                        String(row.row.original.bill_request_pharmafile)
                      )
                        ? row.row.original.bill_request_pharmafile
                        : pdf
                      : noimage
                  }
                ></img>
              </span>
            </>
          );
        },
      },
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {String(row.row.original.patient.p_uhid)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Ph.No",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.phonenumber}
              >
                {String(row.row.original.patient.phonenumber)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Address",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.address.location_range == null
                    ? ""
                    : row.row.original.address.location_range
                }
              >
                {row.row.original.address.address_line2}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let string_convert = String(
                    row.row.original.address.address_line1 +
                    ", " +
                    row.row.original.address.address_line2 +
                    ". " +
                    row.row.original.address.latitude +
                    "," +
                    row.row.original.address.longitude
                  );
                  let isCopy = copy(string_convert);
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Assigned By",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_by}
              >
                {row.row.original.assigned_by == null
                  ? "--"
                  : row.row.original.assigned_by}
              </p>
            </>
          );
        },
      },
      {
        Header: "Assigned To",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_to}
              >
                {row.row.original.assigned_to}
              </p>
            </>
          );
        },
      },
      {
        Header: "Delivery Ph.No",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.phone_number}
              >
                {row.row.original.phone_number == null
                  ? "--"
                  : row.row.original.phone_number}
              </p>
            </>
          );
        },
      },
      {
        Header: "Need Prescription",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.need_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.need_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },
      {
        Header: "No Prescription",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.no_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.no_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },

      {
        Header: "Status",
        accessor: "",
        Cell: (row) => {
          let status_data = row.row.original.status;
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                className={
                  status_data == "Confirming order"
                    ? "ordered"
                    : status_data == "Packing Order"
                      ? "packing"
                      : status_data == "In Transit"
                        ? "enroute"
                        : status_data == "Delivered"
                          ? "done"
                          : ""
                }
                data-tooltip-content={status_data}
              >
                {row.row.original.status}
              </p>
            </>
          );
        },
      },
      // {
      //   Header: "Initial Amount",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <p
      //           data-tooltip-id="my-tooltip"
      //           data-tooltip-content={row.row.original.amount_before}
      //         >
      //           {parseFloat(row.row.original.amount_before).toFixed(2)}
      //         </p>
      //       </>
      //     );
      //   },
      // },
      // {
      //   Header: "Sample amount",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <p
      //           data-tooltip-id="my-tooltip"
      //           data-tooltip-content={row.row.original.base_amount}
      //         >
      //           {parseFloat(row.row.original.base_amount).toFixed(2)}
      //         </p>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Total Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.total_amount}
              >
                {row.row.original.total_amount == null
                  ? "--"
                  : parseFloat(row.row.original.total_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Initial Wallet ",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.previous_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {parseFloat(row.row.original.previous_cashbackpoints).toFixed(
                  2
                )}
              </p>
            </>
          );
        },
      },
      {
        Header: "Wallet amount Used",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.used_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {parseFloat(row.row.original.used_cashbackpoints).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.ordercreaterazorpay != null ? (
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.ordercreaterazorpay.isPaid == false
                      ? "No"
                      : "Yes"
                  }
                >
                  {row.row.original.ordercreaterazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </p>
              ) : row.row.original.fully_used == false ? (
                <p style={{ color: "red", fontWeight: 700 }}>No</p>
              ) : (
                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
              )}
            </>
          );
        },
      },

      {
        Header: "Razorzor pay ID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.ordercreaterazorpay == null
                    ? "--"
                    : row.row.original.ordercreaterazorpay.pharmacy_order_id
                }
              >
                {row.row.original.ordercreaterazorpay == null
                  ? "--"
                  : row.row.original.ordercreaterazorpay.pharmacy_order_id}
              </p>
            </>
          );
        },
      },
    ],
    []
  );
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];
  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Product Order New</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Product Order New</li>
              </ul>
            </div>
            <div class="col-sm-5 col-auto">
              {" "}
              <div className="datepicker_dash">
                <DateRangePicker
                  defaultValue={[
                    // new Date(new Date().setDate(today.getDate() - 30)),
                    new Date(),
                    new Date(),
                  ]}
                  // disabledDate={(date) => isAfter(date, new Date())}
                  editable={false}
                  appearance="default"
                  placement="bottomEnd"
                  size="lg"
                  ranges={predefinedBottomRanges}
                  placeholder="From - To"
                  style={{ width: 270, padding: 10, float: "right" }}
                  onClean={(e) => cleaningrange(e)}
                  onChange={(e) => {
                    if (e != null) {
                      setrange([]);
                      e.forEach((newValue) => {
                        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                        var localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate("validtill", localISOTime);
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="pie_chart"
                style={{ justifyContent: "center", display: "flex" }}
              >
                <Chart
                  chartType="PieChart"
                  data={pie_chart_data}
                  options={options}
                  width={"400px"}
                  height={"250px"}
                />
              </div>
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      class="input-group rounded mr-2 "
                      style={{
                        width: "250px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <p className="mb-0">Select Delivery type</p>
                      <select
                        class="form-select"
                        value={deliveryType}
                        name="status"
                        onChange={(e) => {
                          setDeliveryType(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Filter By Delivery type...
                        </option>
                        <option value={"all"}>All</option>
                        <option value={true}>Hospital</option>
                        <option value={false}>Home</option>
                      </select>
                    </div>
                    <div
                      class="input-group rounded mr-2 "
                      style={{
                        width: "250px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <p className="mb-0">Select Status</p>
                      <select
                        class="form-select"
                        value={pharmaStatus}
                        name="status"
                        onChange={(e) => {
                          setPharmaStatus(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Filter By Status...
                        </option>
                        <option value={"all"}>All</option>
                        <option value={"Confirming order"}>
                          Confirming order
                        </option>
                        <option value={"Packing Order"}>Packing Order</option>
                        <option value={"In Transit"}>In Transit</option>
                        <option value={"Delivered"}>Delivered</option>
                      </select>
                    </div>
                    <div
                      class="input-group rounded mr-2 "
                      style={{
                        width: "250px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <p className="mb-0">Proceed Payment</p>
                      <select
                        class="form-select"
                        value={proceedpaymentstate}
                        style={{ borderRadius: "10px" }}
                        onChange={(e) => {
                          setproceedpaymentstate(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Filter By Proceed Payment...
                        </option>
                        <option value={"True"}>YES</option>
                        <option value={"False"}>NO</option>
                      </select>
                    </div>
                  </div>
                </form>

                <div className="table-responsive">
                  <div className="custom_color">
                    <BasicTable
                      columns={columns}
                      data={tableheaderdata}
                      pagesize={pagesize}
                      pageindex={pageindex}
                      dtpagesize={dtpagesize}
                      dtpageindex={dtpageindex}
                      datacount={datacount}
                      stateid={"1"}
                      settrackorderidp={settrackorderidp}
                      settrackorderstatep={settrackorderstatep}
                      location={"others"}
                      setbranches={setbranches}
                      branches={branches}

                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>

      {productstate == "Edit" ? (
        <ProductOrderFormNew
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}

      {returnpopup && <PharmacyProductReturn
        loaderchange={loaderchangechild}
        popupalert={popupalertchild}
        popuptext={popuptextchild}
        setreturnpopup={setreturnpopup}
        trackorderidp={trackorderidp}
      />}

      {trackorderstatep == true &&
        trackorderdatap != undefined &&
        trackorderdatap != null &&
        trackorderdatap != "" && (
          <>
            <div className="card_parent">
              <div className="card22">
                <span
                  className="cross"
                  onClick={(e) => {
                    settrackorderstatep(false);
                    settrackorderidp("");
                    settrackorderdatap([]);
                  }}
                >
                  {" "}
                  <div className="title">Track Order Status</div>
                  <i class="bi bi-x-lg x"></i>
                </span>

                <div className="info">
                  <div className="row">
                    <div className="col-7">
                      <span id="heading"> Ordered Date</span>
                      <br />
                      <span id="details">
                        {trackorderdatap.order.created_date != null
                          ? trackorderdatap.order.created_date.slice(0, 10) +
                          "  " +
                          timeString
                          : ""}
                      </span>
                    </div>
                    <div className="col-5 pull-right">
                      <span id="heading">Delivery Date</span>
                      <br />
                      <span id="details">
                        {trackorderdatap.order.delivery_date != null
                          ? trackorderdatap.order.delivery_date.slice(0, 10)
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tracking">
                  <div className="title">Tracking Order</div>
                </div>
                <div className="progress-track">
                  <ul id="progressbar">
                    <li
                      className={`step0 ${trackorderdatap.order_placed != null &&
                        trackorderdatap.order_placed != undefined
                        ? "active"
                        : ""
                        }`}
                      id="step1"
                    >
                      Comfirming Order<br></br>
                      <div className="time">
                        {trackorderdatap.order_placed != null &&
                          trackorderdatap.order_placed != undefined
                          ? trackorderdatap.order_placed.time
                          : ""}
                      </div>
                    </li>
                    <li
                      className={`step0  text-center ${trackorderdatap.order_packing != null &&
                        trackorderdatap.order_packing != undefined
                        ? "active"
                        : ""
                        }`}
                      id="step2"
                    >
                      <span style={{ marginRight: "20px" }}>
                        Ready To Dispatch<br></br>
                        <div className="time">
                          {trackorderdatap.order_packing != null &&
                            trackorderdatap.order_packing != undefined
                            ? trackorderdatap.order_packing.time
                            : ""}
                        </div>
                      </span>
                    </li>
                    <li
                      className={`step0 text-right ${trackorderdatap.intransit != null &&
                        trackorderdatap.intransit != undefined
                        ? "active"
                        : ""
                        }`}
                      id="step3"
                    >
                      <span style={{ marginRight: "20px" }}>
                        In Transit<br></br>
                        <div className="time">
                          {trackorderdatap.intransit != null &&
                            trackorderdatap.intransit != undefined
                            ? trackorderdatap.intransit.time
                            : ""}
                        </div>
                      </span>
                    </li>
                    <li
                      className={`step0 text-right ${trackorderdatap.orderdelivered != null &&
                        trackorderdatap.orderdelivered != undefined
                        ? "active"
                        : ""
                        }`}
                      id="step4"
                    >
                      Delivered<br></br>
                      <div className="time">
                        {trackorderdatap.order_placed != null &&
                          trackorderdatap.order_placed != undefined
                          ? trackorderdatap.order_placed.time
                          : ""}
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="pricing">
                  <div className="row">
                    <div className="col-9">
                      <span id="name">Name</span>
                    </div>
                    <div className="col-3">
                      <span id="price">Quantity</span>
                    </div>
                  </div>

                  {trackorderdatap.order.cart_products.map((ele, index) => {
                    if (ele.new_medicine == true) {
                      return (
                        <div className="row">
                          <div className="col-9">
                            {
                              <span id="name">
                                {index + 1 + ". " + ele.medicine_name}
                              </span>
                            }
                          </div>
                          <div className="col-3">
                            <span id="price">{ele.quantity}</span>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="row">
                          <div className="col-9">
                            {ele.pharma != null && (
                              <span id="name">
                                {index + 1 + ". " + ele.pharma.product_name}
                              </span>
                            )}
                          </div>
                          <div className="col-3">
                            <span id="price">{ele.quantity}</span>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </>
        )}
    </>
  );
}

export default ProductOrderNew;
